import { useQuery } from '@tanstack/react-query';
import { strapiListPermissionGroupsMaster } from '../../api/strapiPermissionMaster';
import { queryKeys } from '../queryKeys';

export function usePermissionMasterQuery(jwt: string | null) {
  return useQuery({
    queryKey: queryKeys.permissionMaster(jwt),
    queryFn: () => strapiListPermissionGroupsMaster(jwt!),
    enabled: Boolean(jwt),
  });
}
